module.exports = __webpack_public_path__ + "static/media/ss6_preview.47e982ec.jpg";